/* @flow */

import { rem } from 'polished';

import {
  fadeDuration,
  tintDuration,
  pressDuration,
} from '@e180/ui/lib/token/animation';
import { successColor } from '@e180/ui/lib/token/color';
import { mediumGrey } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

const spinnerWidth = 14; /* small spinner width */
const spinnerWidthWithPadding = `calc(${spinnerWidth}px + 1em)`; /* small spinner width w/ padding */

export default {
  root: {
    position: 'relative',

    overflow: 'hidden',

    width: '100%',
    padding: 16,

    fontSize: rem(15, baseFontSize),
    fontWeight: 600,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',

    transition: `opacity ${fadeDuration}, background-color ${tintDuration}, transform ${pressDuration}, color ${tintDuration}`,
    transformOrigin: 'center center',

    '&:hover': {
      backgroundColor: ({ darkAccentColor }: Object) => darkAccentColor,
    },

    '&:active': {
      transform: 'scale(0.95, 0.95)',
    },

    '&[disabled]': {
      opacity: 0.4,
    },
  },

  'root-isSubmitting': {
    paddingRight: spinnerWidthWithPadding,
    paddingLeft: spinnerWidthWithPadding,

    pointerEvents: 'none',
  },

  'root-isFetching': {
    /* FIXME: overwrite OptionButton color */
    color: ['rgb(0, 0, 0, 0)', '!important'],
    /* FIXME: overwrite accent color background-color */
    backgroundColor: [mediumGrey, '!important'],
  },
  'root-withSuccess': {
    /* FIXME: overwrite accent color background-color */
    backgroundColor: [successColor, '!important'],
  },

  spinner: {
    position: 'absolute',
    top: 0,
    right: '0.5em',
    bottom: 0,

    display: 'flex',
    alignItems: 'center',
  },

  'spinner-isFetching': {
    left: 0,
    right: 0,

    margin: '0 auto',
    width: spinnerWidth,
  },
};
